import {Box, Flex, Image, Text} from '@chakra-ui/react'
import CompletedIcon from '@assets/svgs/progress/completed.svg'
import HappeningIcon from '@assets/svgs/progress/happening.svg'
import UnfinishedIcon from '@assets/svgs/progress/unfinished.svg'
import FlagIcon from '@assets/svgs/flag.svg'
import {useSelector} from 'react-redux'

const Progress = ({
  steps,
  currentIndex,
  currentPercent,
  px,
}: {
  steps: any
  currentIndex: number
  currentPercent: number
  px: any
}) => {
  const {isFinish} = useSelector((state: any) => state.learnPartTwo)

  const getIcon = (itemIndex: number) => {
    if (itemIndex < currentIndex) return CompletedIcon
    if (itemIndex === currentIndex) return HappeningIcon
    if (itemIndex > currentIndex) return UnfinishedIcon
  }

  return (
    <Flex px={px} w={'100%'}>
      {steps?.map((item: any, index: any) => (
        <Flex key={index} flex={1} alignItems={'center'} pt={'24px'}>
          <Box position={'relative'} flexShrink={0}>
            <Text
              position={'absolute'}
              top={'-24px'}
              left={'50%'}
              fontWeight={'600'}
              transform={'translateX(-50%)'}
              textTransform={'uppercase'}
              fontSize={{base: '10px', md: '14px'}}
              color={index === currentIndex ? '#263238' : '#8C8C8C'}
              style={{
                textWrap: 'nowrap',
              }}>
              {item}
            </Text>
            <Image w={{base: '24px', md: '30px'}} src={getIcon(index)} />
          </Box>
          {index < steps.length && (
            <Box
              position={'relative'}
              w={'100%'}
              h={{base: '8px', md: '12px'}}
              bg={'#F0F0F0'}>
              <Box
                position={'absolute'}
                top={0}
                w={`${index < currentIndex || isFinish ? '100%' : `${currentPercent}%`}`}
                h={{base: '8px', md: '12px'}}
                borderRadius={
                  currentPercent < 100 && index === currentIndex
                    ? '0px 6px 6px 0px'
                    : 'unset'
                }
                bg={
                  index <= currentIndex || isFinish
                    ? 'linear-gradient(286deg, #1890FF 25.41%, #18BAFF 94.79%)'
                    : '#F0F0F0'
                }
              />
            </Box>
          )}
        </Flex>
      ))}
      <Image src={FlagIcon} ml={'16px'} />
    </Flex>
  )
}

export default Progress
